import React from 'react';
import { fromPairs, map } from 'lodash';

// local dependencies
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { form as Form } from 'ui/views/demo/form';
 *
 * // render
 * <Form propName='propValue'/>
 */
export const form = (  ) => {

    // JSON reference: jsons/authFlowCallerIdentificationPharmacyWidget.json

    // fields
    const fieldsData = [
        {
          'name': 'title',
          'type': 'text',
          'title': {
            'refId': '',
            'value': 'Title'
          },
          'placeholder': {
            'refId': '',
            'value': 'Enter title'
          },
          'config': {
            'emptyValue': '',
            'validations': []
          }
        },
        {
          'name': 'firstName',
          'type': 'text',
          'title': {
            'refId': '',
            'value': 'First Name'
          },
          'placeholder': {
            'refId': '',
            'value': 'Enter first name'
          },
          'config': {
            'emptyValue': '',
            'validations': [
              {
                'name': 'required',
                'message': {
                  'refId': '',
                  'value': 'Please enter first name.'
                }
              }
            ]
          }
        },
        {
          'name': 'lastName',
          'type': 'text',
          'title': {
            'refId': '',
            'value': 'Last Name'
          },
          'placeholder': {
            'refId': '',
            'value': 'Enter last name'
          },
          'config': {
            'emptyValue': '',
            'validations': [
              {
                'name': 'required',
                'message': {
                  'refId': '',
                  'value': 'Please enter last name.'
                }
              }
            ]
          }
        },
        {
          'name': 'clinicNumber',
          'type': 'textarea',
          'title': {
            'refId': '',
            'value': 'Clinic Number'
          },
          'placeholder': {
            'refId': '',
            'value': 'Enter clinic number'
          },
          'config': {
            'emptyValue': '',
            'validations': []
          }
        }
    ];

    // actions
    const actions = [
        {
            'name': 'save',
            'title': {
                'refId': '',
                'value': 'Save'
            },
            'url': {
                'refId': 'actionSaveCallerDetails',
                'params': {}
            }
        }
    ];
    
    return (
        <div className='ui-form'>

            {/* use form module to manage form */}
            <Form
                fields = { fromPairs( map( fieldsData, field => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                values = { { firstName: 'John' } } // default values
                onSubmit = { ( /*{ values, isValid }*/ ) => {
                  
                    // log.debug( 'on-submit', { values, isValid } );
                } }
            >
                {
                    ( { fields, values, isValid, errors, onChange, onSumbit } = {} ) => {

                        /****************** CUSTOM FORM IMPLEMENTATION ***********************/

                        return (
                            <form onSubmit={ onSumbit }>
                                {/* fields (we are using here `fields` object to render fields but you can render fields however you want ) */}
                                {
                                    map( fields, field => {
                                        return (
                                            <field.view
                                                key={ field.name }
                                                className='ui-form__input'
                                                name={ field.name }
                                                required={ field.required }
                                                placeholder={ field.placeholder }
                                                label={ field.title }
                                                onChange={ onChange }
                                                value={ values[ field.name ] }
                                                error={ errors[ field.name ] }
                                            />
                                        );
                                    } )
                                }
                                
                                {/* actions */}
                                <div className='ui-form__actions'>
                                    {
                                        actions.map( action => (
                                            <Button
                                                disabled={ ! isValid }
                                                type='submit'
                                                size='large'
                                                key={ action.name }
                                                label={ action.title }
                                            />
                                        ) )
                                    }
                                </div>
                            </form>
                        );

                        /********************************************************************/

                    }
                }
            </Form>
        </div>
    );
};

// set display name
form.displayName = 'form';

// set default props
form.defaultProps = {};

// prop types
form.propTypes = {};
